export class SupabaseConfigurationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SupabaseConfigurationError';
  }
}

export class SupabaseOperationError extends Error {
  readonly operation: string;

  constructor(operation: string, message: string) {
    super(`${operation}: ${message}`);
    this.name = 'SupabaseOperationError';
    this.operation = operation;
  }
}

export class SessionUserMismatchError extends Error {
  constructor() {
    super('The requested user does not match the authenticated Supabase session.');
    this.name = 'SessionUserMismatchError';
  }
}
